<template>
  <section class="m-new-product m-scroll" ref="scroll"  @scroll="handleScroll($event)">
    <!-- 头部导航 -->
    <div class="header">
      <img  @click="handleBack" src="@/assets/order/icon-fanhui@2x.png" alt="back">
      <span class="header-img">
        <img src="@/assets/discount/discount-header.png" alt="" class="top-img">
      </span>
      <span style="width: 25px"></span>
    </div>
    
    <!-- 滚动切换 -->
    <van-tabs title-active-color="#ED2A24" title-inactive-color="#000000" v-model="activeSectionId"
    style="position:sticky;top:90px;z-index:99;margin-bottom:16px">
      <van-tab :title="item.title" v-for="(item, index) in classifyList" :key="index" :name="item.id + ',' + item.cid">
      </van-tab>
    </van-tabs>
    <goods-columns v-if="classifyList[activeIndex]" @cartClick="handleCart" :data="goodsList" :loading="loading" :columns="2"></goods-columns>
    <p class="search-no" v-if='noMore'>暂无更多商品</p> 
    
    <van-loading v-show="loading" type="spinner" color="#ED2A24" size="6.4vw"></van-loading>

    <!-- 选择SKU 加入购物车 -->
    <m-sku title="加入购物车" :show="skuModal" @close="val=>skuModal=val" @success="handleCartSuccess" :goodsId="goodsId"></m-sku>

    <!-- 加入购物车动画 -->
    <m-animate :start="start" :dom="start_dom" @end="handleCartEnd"></m-animate>

    <!-- 购物车浮窗 -->
    <transition name="van-fade">
        <CartFlex v-if="start" />
    </transition>
  </section>
</template>

<script>
import MSku         from '@/components/zh/m-sku.vue'
import GoodsColumns from '@/components/zh/goods-columns.vue'
import MAnimate     from '@/components/zh/cart-animate.vue'
import CartFlex     from '@/components/zh/cart-flex.vue'

import { getWelfareList } from '@/api/en/mooby.js'
import { getTypeGoodsList } from '@/api/en/gift.js'
import MixinScroll from '@/untils/js/mixin-scroll.js'
export default {
  mixins: [ MixinScroll ],
  name:'Index',
  components:{  GoodsColumns, MSku, MAnimate, CartFlex },
  data(){
    return {
      offsetTop:0,
      tab:0,          // tabs选中的面板
      loading:false,
      skuModal:false,
      tabTop:44,
      dotAnimate:false,
      start:false,
      start_dom:null,
      cartNum:0,
      scrollTop:false,
      goodsList: [],
      page: 1,
      islock: false,
      noMore: false,
      activeSectionId: 0,
      classifyList: [],
      activeIndex: 0,
      goodsId: '',
    }
  },

  mounted(){
    let clientWidth = document.body.clientWidth
    this.tabTop = 44/375*clientWidth

    this.getNewSaleClassifyHandle()
  },

  methods:{
    // 内容滑动事件
    handleScroll(e){
      this.offsetTop = e.target.scrollTop

      if(e.target.scrollHeight - e.target.clientHeight- e.target.scrollTop <= 50){
        if(!this.islock && !this.noMore){
          e.preventDefault()
          e.stopPropagation()
          this.loading = true
          this.page++
          this.getNewSaleClassifyGoodsHandle()
        }
        this.islock = true
      }
    },
    handleBack(){
      this.$router.go(-1)
    },

    // 切换 tab
    handleTab(tab){
      let left = 6.56667 + tab  * 21.66667
      this.$refs.tabActive.style.left = left + 'vw'
      this.tab = tab
    },
    // 商品列表购物车点击事件
    handleCart(goods,e){
      this.goodsId = goods
      this.skuModal  = true
      this.start_dom = e 
    },
     // sku 弹窗加入购物车成功回调
    handleCartSuccess(){
      this.skuModal = false
      let timer = setTimeout( () => {
        this.start  = true
        this.dotAnimate = true 
        this.cartNum ++

        let timer1 = setTimeout(()=> {
          this.dotAnimate = false
          clearTimeout(timer1)
        },400)

        clearTimeout(timer)
      },300)
    },
    // 加入购物车动画结束
    handleCartEnd(){
      this.start    = false
    },
    getNewSaleClassifyHandle() {
      // 获取新品分类
      getWelfareList(5).then(res => {
        if(res) {
          this.classifyList = res.data
          if(res.data.length > 0) {
            this.activeSectionId = res.data[0].id + ',' + res.data[0].cid
          }
        }
      })
    },
    getNewSaleClassifyGoodsHandle() {
      // 获取新品分类商品
      this.islock = true
      this.loading = true
      getTypeGoodsList({page: this.page, type_id: this.activeSectionId.split(',')[0], cid: this.activeSectionId.split(',')[1]}).then(res => {
        this.loading  = false
        this.islock   = false
        if(res) {
          this.goodsList = this.goodsList.concat(res.data.data)
        }else{
          this.noMore = true
        }
      })
    },
  },
  watch: {
    activeSectionId(val) {
      if(val) {
        this.classifyList.forEach((el, index) => {
          if(el.id == val) {
            this.activeIndex = index
          }
        })
        this.goodsList = []
        this.page = 1
        this.islock   = false
        this.noMore = false
        this.getNewSaleClassifyGoodsHandle()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-no {
  line-height:80px;
  text-align:center;
  color:#888;
  font-size:14px;
}
@import './index.less';
</style>